export enum PaymentStatus {
  Initiating = "INITIATING",
  Cancelled = "CANCELLED",
  Completed = "COMPLETED",
  Failed = "FAILED",
  Pending = "PENDING",
  Expired = "EXPIRED",
}
